import React from 'react';
import PropTypes from 'prop-types';
import { prettyNumber, metersToMiles, squareMetersToAcres, asTime } from '../../../../../lib/utils';
import DataPoint from '../DataPoint';
import Divider from '../Divider';

export default function TrackStats(props) {
  const track = props.feature;

  const hasGeometry = () => {
    return track && track.geometry && track.geometry.coordinates;
  };

  const getTime = () => {
    if (
      hasGeometry() &&
      track.properties != null &&
      track.properties.duration != null &&
      track.properties.duration !== 0
    ) {
      return asTime(track.properties.duration);
    }
    return '--';
  };

  const getDistance = () => {
    if (
      hasGeometry() &&
      track.properties != null &&
      track.properties.distance != null &&
      track.properties.distance !== 0
    ) {
      return prettyNumber(metersToMiles(track.properties.distance), 2);
    }
    return '--';
  };

  const getAvgSpeed = () => {
    if (
      hasGeometry() &&
      track.properties != null &&
      track.properties.averageSpeed != null &&
      track.properties.averageSpeed !== 0
    ) {
      return prettyNumber(track.properties.averageSpeed, 2);
    }
    return '--';
  };

  return (
    <>
      <DataPoint title='Time'>
        { getTime() }
      </DataPoint>
      <Divider margin={24} />
      <DataPoint title='Distance'>
        { getDistance() + ' miles'}
      </DataPoint>
      <Divider margin={24} />
      <DataPoint title='Avg. Speed'>
        { getAvgSpeed() + ' mph' }
      </DataPoint>
    </>
  );
}

TrackStats.propTypes = {
  feature: PropTypes.object,
};
